/**
 * 环保局相关信息修改
 * 2019-09-05 chenxiaojian
 */
import React, { Component } from 'react';
import { Modal, Form, Input, Row, Col, Switch, InputNumber, DatePicker, Divider, Select, Descriptions, Icon } from 'antd';
import moment from 'moment';


import http from '../../../axios/http';
import validator from '../../../util/validator';

import messager from '../../ui/messager';
import DictSelect from '../../ui/DictSelect';

import Loading from '../../ui/Loading';
import { checkIdNo } from '../../../util/util.js'

const FormItem = Form.Item;

const field = [{
    "text": "业务类型",
    "field": "tradeVehicleType",
    "select": true,
    "category": "TRADE_VEHICLE_TYPE",
    rules: [
        { required: true, message: '业务类型不能为空!' }
    ],
    "onSelect": true,
    "payState": true
}, {
    "text": "服务费用",
    "field": "commission",
    "number": true,
    "payState": true,
    rules: [
        { required: true, message: '服务费用不能为空!' }
    ],
    // disabled: true
}, {
    "text": "车价合计",
    "field": "amount",
    "number": true,
    rules: [
        { required: true, message: '车价合计不能为空!' }
    ],
}, {
    "text": "车辆转入地",
    "field": "destination",
    rules: [
        { required: true, message: '车辆转入地不能为空!' }
    ],
}, {
    "text": "车牌号码",
    "field": "vehicle.plateNo",
    rules: [
        { required: true, message: '车牌号码不能为空!' },
        validator.plateNo
    ]
}, {
    "text": "车架号",
    "field": "vehicle.vin",
    rules: [
        { required: true, message: '车架号不能为空!' },
        { max: 32, message: '车架号不能超过32个字符！' },
        validator.enNum
    ]
}, {
    "text": "登记证书编号",
    "field": "vehicle.registerNo",
    rules: [
        { required: true, message: '登记证书编号不能为空！' },
        { max: 12, message: '登记证书编号为12位数字！' },
        { min: 12, message: '登记证书编号为12位数字！' },
        validator.num
    ]
}, {
    "text": "车辆类型",
    "field": "vehicle.vehicleType",
    "category": "VEHICLE_TYPE",
    select: true,
    needPull: true,
    onSelect: true,
    rules: [
        { required: true, message: '车辆类型编号不能为空!' },
    ]
}, {
    "text": "厂牌型号",
    "field": "vehicle.brandModel",
    rules: [
        { required: true, message: '厂牌型号不能为空!' },
        { max: 64, message: '厂牌型号不能超过64个字符！' },
    ]
}, {
    "text": "自带交易票",
    "field": "selfTicket",
    "radio": true,
    "selfTicket": true
}];


const buyer = [{
    "text": "证件编号",
    "field": "buyer.creditNo",
    rules: [
        { required: true, message: '证件编号不能为空!' },
        validator.enNum
        // validator.creditNo
    ]
}, {
    "text": "买方姓名",
    "field": "buyer.name",
    rules: [
        { required: true, message: '买方姓名不能为空!' },
        { max: 64, message: '买方姓名不能超过32个字符！' },
    ]
}, {
    "text": "联系电话",
    "field": "buyer.tel",
    rules: [
        { required: true, message: '联系电话不能为空!' },
        validator.tel
    ]
}, {
    "text": "居住地址",
    "field": "buyer.residenceAddress",
    "textarea": true,
    rules: [
        { required: true, message: '居住地址不能为空!' },
        { max: 128, message: '居住地址不能超过128个字符！' },
    ]
}, {
    "text": "纳税类型",
    "field": "buyerType",
    defSelect: true,
    dictList: [{
        code: 1,
        name: '个人'
    }, {
        code: 2,
        name: '小规模'
    }, {
        code: 3,
        name: '一般纳税人'
    }, {
        code: 4,
        name: '一般纳税人-固定资产'
    }]
}];

const seller = [{
    "text": "证件编号",
    "field": "seller.creditNo",
    rules: [
        { required: true, message: '证件编号不能为空!' },
        validator.enNum
        // validator.creditNo
    ]
}, {
    "text": "卖方姓名",
    "field": "seller.name",
    rules: [
        { required: true, message: '买方姓名不能为空!' },
        { max: 64, message: '买方姓名不能超过32个字符！' },
    ]
}, {
    "text": "联系电话",
    "field": "seller.tel",
    rules: [
        { required: true, message: '联系电话不能为空!' },
        validator.tel
    ]
}, {
    "text": "居住地址",
    "field": "seller.residenceAddress",
    "textarea": true,
    rules: [
        { required: true, message: '居住地址不能为空!' },
        { max: 128, message: '居住地址不能超过128个字符！' },
    ]
}, {
    "text": "纳税类型",
    "field": "sellerType",
    defSelect: true,
    dictList: [{
        code: 1,
        name: '个人'
    }, {
        code: 2,
        name: '小规模'
    }, {
        code: 3,
        name: '一般纳税人'
    }, {
        code: 4,
        name: '一般纳税人-固定资产'
    }]
}, {
    "text": "备注",
    "field": "remark",
    "textarea": true,
    rules: [
        { max: 128, message: '备注不能超过128个字符！' },
    ]
}];

// const other = [{
//     "text": "备注",
//     "field": "remark",
//     "textarea": true,
//     rules: [
//         { max: 128, message: '居住地址不能超过128个字符！' },
//     ]
// }];

class TicketEditForm extends Component {
    state = {
        tradeVehicleTypeStr: null,
        vehicleTypeStr: null,
        loadingVisible: false,

        taxpayerRecord: null
    }

    componentDidMount() {
        if (this.props.initEdit) {
            this.props.initEdit(this.queryTaxpayerType);
        }
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            this.setState({ loadingVisible: true });
            values.buyer.id = this.props.editData["buyer.id"];
            values.buyer.creditType = this.props.editData["buyer.creditType"];
            values.seller.id = this.props.editData["seller.id"];
            values.seller.creditType = this.props.editData["seller.creditType"];
            values["applicationId"] = this.props.editData.applicationId;

            if (values["selfTicket"]) {
                values["state"] = 3;    //自带交易票
            }

            this.transferData(values, "buyer");
            this.transferData(values, "seller");
            this.transferData(values, "vehicle");

            http.post({
                url: '/application/saveApplyTicketInfo',
                data: values,
                success: (res) => {
                    this.changePrintValue(field, values);
                    this.changePrintValue(seller, values);
                    this.changePrintValue(buyer, values);
                    //this.changePrintValue(other, values);

                    let editData = this.props.editData;
                    if (this.state.vehicleTypeStr != null && this.state.vehicleTypeStr !== "") {
                        editData["vehicleTypeStr"] = this.state.vehicleTypeStr;
                        this.setState({ vehicleTypeStr: null });
                    }
                    if (this.state.tradeVehicleTypeStr != null && this.state.tradeVehicleTypeStr !== "") {
                        editData["tradeVehicleTypeStr"] = this.state.tradeVehicleTypeStr;
                        this.setState({ tradeVehicleTypeStr: null });
                    }

                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();

                    this.props.reloadData();

                    messager.notify("保存成功！");
                    this.setState({ loadingVisible: false });
                },
                error: (res) => {
                    messager.alert(res, "异常", "error");
                    this.setState({ loadingVisible: false });
                }
            });
        });
    };

    //swith选择改变时触发
    radioChange = (field, checked) => {
        if (field === "selfTicket") {
            if (checked) {
                messager.alert("选择自带交易票的会将生成一条空的交易票信息，请谨慎操作！", "提醒", "warning");
            }
        }
    }

    changePrintValue(field, values) {
        let editData = this.props.editData;
        field.forEach((item, index, arr) => {
            editData[item.field] = values[item.field];
        });
    }

    transferData = (res, field) => {
        let value = res[field];
        for (let key in value) {
            res[field + "." + key] = value[key];
        }
        delete res[field];
    }

    //字典选择改变时触发
    dictSelect = (field, dict) => {
        if (dict != null) {
            const { form } = this.props;
            if (field === "tradeVehicleType") {
                form.setFieldsValue({
                    "commission": dict.des
                });
                this.setState({ tradeVehicleTypeStr: dict.name });
            } else if ("vehicle.vehicleType") {
                this.setState({ vehicleTypeStr: dict.name });
            }
        }
    }

    createDom = (data) => {
        let dom = [];
        for (let i = 0; i < data.length; i += 2) {
            let item = (<Row key={i}>
                <Col span={11}>
                    {this.createDomItem(data[i])}
                </Col>
                <Col span={11} offset={2}>
                    {(i + 1) < data.length ? this.createDomItem(data[i + 1]) : ''}
                </Col>
            </Row>);
            dom.push(item);
        }
        return dom;
    };
    createDomItem = (item) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let payState = editData.payState;
        return (
            <FormItem label={item.text + "："}>
                {
                    getFieldDecorator(item.field, {
                        rules: item.rules,
                        initialValue:
                            item.date ? (editData[item.field] == null || editData[item.field] === "" ? null : moment(editData[item.field]))
                                : item.radio ? editData[item.field] === 1
                                    : item.defSelect ? editData[item.field] + ""
                                        : editData[item.field],
                        valuePropName: item.radio ? 'checked' : 'value'
                    })(
                        item.select ?
                            <DictSelect category={item.category} onSelect={item.onSelect ? this.dictSelect.bind(this, item.field) : null}
                                disabled={item.payState === true && ((payState === 1 && editData.agent === 0) || editData.disabledCommission === true)}
                            />
                            : item.defSelect ?
                                <Select>
                                    {item.dictList.map(d => <Select.Option key={d["code"]}>{d["name"]}</Select.Option>)}
                                </Select>
                                : item.radio ?
                                    <Switch checkedChildren="是" unCheckedChildren="否" onChange={this.radioChange.bind(this, item.field)}
                                        disabled={item.selfTicket === true && editData["needDeduction"] === true}
                                    />
                                    : item.number ?
                                        <InputNumber precision={2} min={0.00} style={{ width: '100%' }}
                                            disabled={item.payState === true && ((payState === 1 && editData.agent === 0) || editData.disabledCommission === true)} />
                                        : item.date ?
                                            <DatePicker style={{ width: '100%' }} />
                                            : item.textarea ? <Input.TextArea disabled={item.disabled === true} />
                                                : <Input onChange={this.inputChange.bind(this, item.field)} disabled={item.disabled === true} />
                    )
                }
            </FormItem>
        );
    }

    /** 输入框变动的时候 */
    inputChange = (field, e) => {
        if (field === "seller.creditNo") {
            const { value } = e.target;
            let taxQueryVisible = checkIdNo(value);
            this.setState({ taxQueryVisible: taxQueryVisible });
        }
    }

    //查询纳税人类型
    queryTaxpayerType = (requery, creditNo) => {
        let taxQueryVisible = checkIdNo(creditNo);
        this.setState({ taxQueryVisible: taxQueryVisible });
        if (!taxQueryVisible) {
            http.get({
                url: '/application/findTaxpaeryType',
                data: {
                    requery: requery,
                    creditNo: creditNo
                },
                success: (res) => {
                    this.setState({ taxpayerRecord: res });
                    if (requery === 1) {
                        messager.notify("查询成功！");
                    }
                }
            });
        }
    }

    clickQueryTaxpayerType = () => {
        const { form } = this.props;
        let creditNo = form.getFieldValue("seller.creditNo");
        this.queryTaxpayerType(1, creditNo)
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={900}
                visible={visible}
                title="交易票相关信息修改"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => {
                    this.props.form.resetFields();
                    this.setState({ taxpayerRecord: null });
                }}
            >
                <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    {this.createDom(field)}
                    <Divider orientation="left">买方信息</Divider>
                    {this.createDom(buyer)}
                    <Divider orientation="left">卖家信息</Divider>
                    {this.createDom(seller)}
                    {/* {this.createDom(other)} */}
                </Form>
                {
                    this.state.taxQueryVisible ? "" :
                        <Row>
                            <Col>
                                <Descriptions title="" bordered column={2}>
                                    <Descriptions.Item label={"上次查询时间："}>{this.state.taxpayerRecord != null ? this.state.taxpayerRecord.insertTime : ""}</Descriptions.Item>
                                    <Descriptions.Item label={"查询结果："}>{
                                        this.state.taxpayerRecord != null ?
                                            { 1: "个人", 2: "小规模", 3: "一般纳税人", 4: "固定资产的一般纳税人" }[this.state.taxpayerRecord.resultType]
                                            : "未查询到数据"
                                    }</Descriptions.Item>
                                    <Descriptions.Item label={"状态："}>{this.state.taxpayerRecord != null ? this.state.taxpayerRecord.status : ""}</Descriptions.Item>
                                    <Descriptions.Item label={"重新查询："}>
                                        <Icon type="search" className="table-operate-icon"
                                            style={{ color: '#1890ff' }}
                                            onClick={this.clickQueryTaxpayerType} />
                                    </Descriptions.Item>
                                </Descriptions>
                            </Col>
                        </Row>
                }
                <Loading
                    visible={this.state.loadingVisible}
                    message="正在保存"
                />
            </Modal>
        );
    }
}

const TicketEdit = Form.create()(TicketEditForm);

export default TicketEdit;